export default {
    async next({ dispatch, rootState }) {
        let panel
        try {
            rootState.preferences.every(preference => {
                if (preference.responses.some(response => response.selected)) {
                    return true
                }
                panel = preference
                return false
            })
        }
        catch (e) {
            console.log(e)
        }
        return panel || {}
    },

    async set({ commit, getters }, payload) {
        let preference = getters.current
        commit('set', { preference: preference, responses: payload })
    },
    
    async clearResponses({ commit, getters }, payload) {
        payload.panel.responses.forEach( r => {
            r.selected = false
        })
    },
}
